<app-admin-sidebar></app-admin-sidebar>
<app-adminheader></app-adminheader>
<div class="dash">
  <div class="trip-acoordion">
    <div class="dash-trucks-top1">
      <a [ngClass]="{ active: selectedWOType == 'present_work_order' }"
        (click)="getTripsList('present_work_order')">Ongoing</a>
      <a [ngClass]="{ active: selectedWOType == 'completed' }" (click)="getTripsList('completed')">Completed</a>
      <a [ngClass]="{ active: selectedWOType == 'cancelled' }" (click)="getTripsList('cancelled')">Cancelled</a>
    </div>
    <div class="dash-trucks-top2">
      <button type="button" class="button buttonBlue fixed-btn" *ngIf="WoCreate"
        (click)="CreateWorkorder(selectedType)">
        <img class="trucks-head-img" src="../../../assets/img/plus-white.svg" />
        Work Order
      </button>
      <button type="button" class="button delete-btn fixed-btn m-rl" *ngIf="selectWO" (click)="selectedWO()">
        <img class="trucks-head-img" src="../../../assets/img/check-circle.svg" />
        Select
      </button>
      <button type="button" class="button delete-btn fixed-btn m-rl" *ngIf="CancelWO" (click)="cancelWO()">
        Cancel
      </button>
      <button type="button" class="button delete-btn fixed-btn m-rl" *ngIf="deleteWO" (click)="deleteWorkOrder()">
        <img class="trucks-head-img" src="../../../assets/img/delete.svg" />
        Delete
      </button>
      <button type="button" *ngIf="searchButton" class="button search-btn fixed-btn" (click)="openSearch()">
        <img src="../../../assets/img/search-white.svg" />
      </button>
      <div *ngIf="toggleSearch" class="search_toggle">
        <input appAlphanumericOnly toUppercase class="search pl-2" placeholder="WO Number" id="searchWorkOrder" #newItem
          (keyup)="onInputChange(newItem)" (keyup.enter)="isInputValid && search(newItem.value)" />
        <button [disabled]="!isInputValid" *ngIf="search_btn" class="search_number" (click)="search(newItem.value)">
          <img src="../../../assets/img/search-white.svg" />
        </button>
        <button type="button" *ngIf="clear_Btn" class="search_number1" (click)="cancelWO()">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor">
            <path
              d="M5.28 4.22a.75.75 0 0 0-1.06 1.06L6.94 8l-2.72 2.72a.75.75 0 1 0 1.06 1.06L8 9.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L9.06 8l2.72-2.72a.75.75 0 0 0-1.06-1.06L8 6.94 5.28 4.22Z" />
          </svg>
        </button>
      </div>
    </div>
    <div class="trucks">
      <div [class.spinner]="loading"></div>

      <div class="row to_container" *ngIf="!workorderArray?.length && !loading">
        <h4 class="error_msg">No Records Found.</h4>
      </div>
      <div class="row" *ngIf="ongoing && workorderArray.length && !loading">
        <div class="col-md-3 mb-3" *ngFor="let work_order of workorderArray">
          <div class="truckscol" [class.expired]="work_order.remaining_tons === 0">
            <!-- Watermark for Expired Work Orders -->
            <!-- <div *ngIf="work_order.remaining_tons === 0" class="watermark">
              Expired
            </div> -->
            <mat-radio-button *ngIf="checkBox" (change)="matItem(work_order)"></mat-radio-button>
            <a *ngIf="work_order.work_order_status != 'completed'" matTooltip="Add Trip to WO"
              matTooltipPosition="above" class="ticket" (click)="Editworkorder(work_order)">{{ work_order.workorder_id
              }}</a>
            <a *ngIf="work_order.work_order_status === 'completed'" matTooltip="Add Trip to WO"
              matTooltipPosition="above" class="ticket">{{ work_order.workorder_id }}</a>

            <img *ngIf="
                work_order.work_order_status !== 'completed' &&
                work_order.remaining_tons > 0
              " matTooltip="Push Notification to near by drivers" matTooltipPosition="above"
              src="../../../assets/img/lorry.svg" class="avat" (click)="addWorkOrder(work_order)" />
            <img *ngIf="
                work_order.work_order_status !== 'completed' &&
                work_order.remaining_tons > 0
              " matTooltip="Edit Work Order" matTooltipPosition="above" src="../../../assets/img/admin-edit.svg"
              class="editimg" (click)="EditsWorkOrder(work_order)" />
            <img matTooltip="View Work Order" matTooltipPosition="above" src="../../../assets/img/eye.png" class="avat"
              (click)="viewWorkOrder(work_order)" />
            <img *ngIf="
                work_order.work_order_status !== 'completed' &&
                work_order.remaining_tons > 0
              " matTooltip="Do Truck Owner" matTooltipPosition="above" src="../../../assets/img/avataar.svg"
              class="editimg" (click)="doWorkOrder(work_order)" />

            <div class="payment-container">
              <div class="location-payment">
                <!-- <img src="../../../assets/img/location-payment.svg" alt="" /> -->
                <img [src]="work_order.stops?.length > 0
                          ? '../../../assets/img/location-payment-stop.svg' 
                          : '../../../assets/img/location-payment.svg'"
                  [matTooltip]="work_order.stops?.length > 0 ? ('Stops: ' + work_order.stops.length) : ''"
                  [matTooltipDisabled]="!(work_order.stops?.length > 0)" matTooltipPosition="right" alt="" />
                <span class="places">
                  <span>{{ work_order.pickup_details.from_city_name }}</span>
                  <span>{{ work_order.dropoff_details.to_city_name }}</span>
                </span>
              </div>
              <div class="payment">
                <div class="amount">Total Tons</div>
                <div class="amount">{{ work_order.total_tons }}</div>
                <div class="tax">Tons</div>
              </div>
            </div>
            <p class="truck-date">
              Price per ton: ₹{{ work_order.price_per_ton | number : '1.0-2' }}
            </p>
            <p class="truck-date">
              Truck Category:
              {{ work_order.truck_category_name }}
            </p>
            <p class="truck-date">
              Updated Date:
              {{ work_order.updated_date ? (work_order.updated_date | date : "dd-MM-yyyy, hh:mm a") : "-" }}
            </p>
          </div>
        </div>
      </div>
      <div *ngIf="last_page && last_page > 1" class="pagination">
        <button class="btn" [disabled]="fetch_page == 1" (click)="pagination('-1')">
          <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24"
            stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <button class="btn" [disabled]="fetch_page == 1" (click)="pagination('first')">
          <img src="../../../assets/img/pagination-left.svg" alt="" class="btn--icon" />
        </button>
        <div class="pages">
          <a class="page" *ngIf="fetch_page > 0">{{ fetch_page }}</a>
        </div>
        <button class="btn" [disabled]="last_page == fetch_page" (click)="pagination('last')">
          <img src="../../../assets/img/pagination-right.svg" alt="" class="btn--icon" />
        </button>
        <button class="btn" [disabled]="last_page == fetch_page" (click)="pagination('1')">
          <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24"
            stroke="currentColor" stroke-width="2">
            <path stroke-linecap=" round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</div>